import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
import router from '@/router/index';
import store from '@/store/index';
import { formatDate } from '@/utils/filters';

Vue.filter('formatDate', formatDate);
Vue.use(Meta);

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
